import axios, { AxiosError } from 'axios'

const userRole = sessionStorage.getItem('userRole') as string

const request = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_URL,
  withCredentials: true,
  headers: {
    'X-Access-Role': userRole as string,
  },
})

const errorHandler = (error: AxiosError) => {
  // if (error.response) {
  // const code = error.response.status
  // switch (code) {
  //   case 403:
  //     if (router.currentRoute.value.name !== 'login' && error.config.url !== '/auth/who_am_i/') {
  //       alert(`Access denied for ${error.config.url}, check the user roles or token`)
  //     }
  //     break
  //   default:
  //   // if (error.response.data) {
  //   //   // alert((error as any)?.response?.data?.detail)
  //   // } else alert(JSON.stringify(error.response))
  // }
  // console.log('err', error)
  // }
  return Promise.reject(error)
}

request.interceptors.request.use((config) => {
  if (!config.headers) config.headers = {}
  config.headers['X-Access-Role'] = sessionStorage.getItem('userRole') as string
  // Some basic req configs
  return config
}, errorHandler)

/* response */
request.interceptors.response.use((response) => {
  return response
}, errorHandler)

export default request
